export const selectConfiguracoes = state => state.configuracoes;
